<template>
  <div class="device-view">
    <Header/>
    <div class="container">
      <router-link to="/dashboard" class="flex-v-center md-hidden">
        <svg class="rotate-180 mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 8H14M14 8L6.92857 1M14 8L6.92857 15" stroke="#9485EF" stroke-width="2"/>
        </svg>
        {{ $lang.messages.back }}
      </router-link>
      <div v-if="devices" class="device-wrapper">
        <div class="flex-between">
          <div class="text-lg text-uppercase mb-3 mt-3 text-bold">{{ activeDevice.name }} settings</div>
          <div class="flex-v-center pointer" @click="removeDeviceModal = true"><i class="icon-trash"></i>&nbsp;Delete</div>
        </div>
        <div class="content-block-item device-setting">
          <div class="device-setting-icon mobile-hidden">
            <img src="../assets/img/device/device-name.svg" alt="device name">
          </div>
          <div class="device-setting-content">
            <label for="deviceName" class="form-label">Device name</label>
            <input id="deviceName" type="text" :value="activeDevice.name" maxlength="20"
                   @input="changeDeviceName($event.target.value)"
                   placeholder="Enter device name" class="form-control">
          </div>
        </div>
        <div class="content-block-item device-setting">
          <div class="device-setting-icon mobile-hidden">
            <img src="../assets/img/device/device-locked.svg" alt="device lock">
          </div>
          <div class="flex-between flex-v-center device-setting-content">
            <div class="mb-xs-1">
              <div class="device-setting-title">{{ $lang.messages.settings.lock_configuration.lock_start }}</div>
              <div class="text-thin">{{ $lang.messages.settings.lock_configuration.lock_start_desc }}</div>
            </div>
            <div>
              <Checkbox :checkboxModel="{'lockOnStart':activeDevice.lockOnStart}" @changecheckbox="updateSettings"/>
            </div>
          </div>
        </div>
        <div class="content-block-item device-setting">
          <div class="device-setting-icon mobile-hidden">
            <img src="../assets/img/device/device-lock-auto.svg" alt="device auto lock">
          </div>
          <div class="flex-between flex-v-center device-setting-content ">
            <div class="mb-xs-1">
              <div class="device-setting-title">
                {{ $lang.messages.settings.lock_configuration.auto_lock }}&nbsp;
              </div>
              <div class="text-thin">{{ $lang.messages.settings.lock_configuration.auto_lock_desc }}</div>
            </div>
            <div>
              <v-select
                  :label="autolockOptions.label"
                  :value="autolockOptions.find(item => item.value === activeDevice.autoLock)"
                  :options="autolockOptions"
                  :clearable="false"
                  :searchable="false"
                  :disabled="!isPremium"
                  @input="changeAutoLock">
                <template slot="open-indicator">
                  <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
                  </svg>
                </template>
              </v-select>
            </div>
          </div>

        </div>
        <div class="content-block-item device-setting">
          <div class="device-setting-icon mobile-hidden">
            <img src="../assets/img/device/device-full-screen.svg" alt="device full screen">
          </div>
          <div class="flex-between flex-v-center device-setting-content">
            <div class="mb-xs-1">
              <div class="device-setting-title">{{ $lang.messages.settings.lock_configuration.always_top }}</div>
              <div class="text-thin">{{ $lang.messages.settings.lock_configuration.always_top_desc }}</div>
            </div>
            <div>
              <Checkbox :checkboxModel="{'alwaysTop': activeDevice.alwaysTop}"
                        @changecheckbox="updateSettings"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="removeDeviceModal" @hidemodal="removeDeviceModal = false">
      <div slot="header">Removing device</div>
      <div slot="content">
        <div class="text-center mb-1">
          Are you sure, you want to remove this device?
        </div>
        <div class="text-center">
          <button class="btn btn-outline mr-1" @click="removeDeviceModal = false">Close</button>
          <button class="btn btn-main ml-1" @click="removeDevice">Remove</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import saveSetting from '../components/mixins/saveSetting'
import Checkbox from "@/components/Checkbox";
import Header from "@/components/Header";
import Modal from "@/components/common/Modal";

export default {
  name: 'Profile',
  mixins: [saveSetting],
  data: function () {
    return {
      isAndroid: window.Android,
      activeDeviceIndex: this.$route.params.deviceID,
      removeDeviceModal: false,
      autolockOptions: [
        {
          label: 'Off',
          value: 0,
        },
        {
          label: '30 sec',
          value: 30,
        },
        {
          label: '1 min',
          value: 60,
        },
        {
          label: '5 min',
          value: 300,
        },
        {
          label: '10 min',
          value: 600,
        },
        {
          label: '30 min',
          value: 1800,
        }
      ],
    }
  },
  components: {
    Modal,
    Header,
    Checkbox
  },
  computed: {
    activeDevice() {
      return this.devices[this.$route.params.deviceID] || null
    },
    ...mapState({
      isPremium: state => state.accountData.isPremium,
      devices: state => state.accountData.devices,
      user: state => state.user.uid
    })
  },
  methods: {
    removeDevice(){
      console.log(this.activeDeviceIndex);
      this.$router.push('/dashboard');
      this.saveDeviceSettings(this.activeDeviceIndex, null, true)
    },
    changeDeviceName(value){
      if(value !== ' '){
        this.saveDeviceSettings(this.activeDeviceIndex, {'name': value.trim()})
      }
    },
    changeAutoLock(value) {
      this.saveDeviceSettings(this.activeDeviceIndex, {'autoLock': value.value})
    },
    updateSettings(keyName, value) {
      this.saveDeviceSettings(this.activeDeviceIndex, {[keyName]: value})
    },
  },

}
</script>

<style lang="scss">
@import "../assets/styles/helpers";
  .device {
     &-wrapper {
       max-width: 1020px;
       margin: 0 auto;

       .account-settings:before {
         @include responsive-below($sm){
           margin-right: 10px;
         }
       }
     }

      &-setting {
        display: flex;
        align-items: flex-start;

        @include responsive-below($xs){
          display: block;
        }

        &-icon {
          width: 10%;
          margin-right: 16px;

          @include responsive-below($sm){
            width: 20%;
          }

          @include responsive-below($xs){
            float: left;
            width: 30px;
          }

          &.-highlight {
            position: relative;

            img {
              position: relative;
            }

            &:before {
              content: "";
              display: block;
              width: 70px;
              height: 70px;
              border-radius: 50%;
              background: #FFD02A;
              position: absolute;
              left: -10px;
              bottom: -10px;

              @include responsive-below($xs){
                width: 30px;
                height: 30px;
                left: 0;
                bottom: 0;
              }
            }
          }
        }

        &-content {
          width: 100%;

          @include responsive-below($sm){
            width: 80%;
          }

          @include responsive-below($xs){
            flex-direction: column;
            width: 100%;

            &.flex-v-center {
              align-items: flex-start;
            }
          }
        }

        &-title {
          font-weight: 700;
          font-size: 22px;

          @include responsive-below($xs){
            margin-top: 10px;
          }
        }
      }
  }
</style>


